// removed by extract-text-webpack-plugin
module.exports = {"container":"Z0Tc7Gb3N-4zFY05pl8WQ","containerInner":"_2FpUCSxDDyG7_PBCngRcC-","item":"ANNbRFn6MDy-xNjJmvF8p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/banner_nav/banner_nav.css
// module id = 162
// module chunks = 0